import { AclTemplateRecord, IAclTemplateData, aclTemplateFromJSON } from "common/records/AclTemplateRecord";
import { List, Map, Record, fromJS } from "immutable";

export const allowedAclFromJSON = (json: Partial<IAllowedAclData>): AllowedAclRecord => {
  const recordData: IAllowedAclRecord = { ...(json as any) };

  if (recordData.acl) {
    recordData.acl = fromJS(recordData.acl);
  }

  if (recordData.templates) {
    recordData.templates = List<AclTemplateRecord>(recordData.templates.map(aclTemplateFromJSON));
  }

  return new AllowedAclRecord(recordData);
};

export interface IAllowedAclData {
  acl: { [key: string]: string[] };
  templates: IAclTemplateData[];
}

export interface IAllowedAclRecord {
  acl: Map<string, List<string>>;
  templates: List<AclTemplateRecord>;
}

export const defaultAllowedAcl: IAllowedAclRecord = {
  acl: Map<string, List<string>>(),
  templates: List<AclTemplateRecord>(),
};

export class AllowedAclRecord extends Record(defaultAllowedAcl) implements IAllowedAclRecord {}
